<template>
    <div class="card">
        <div class="card-content">
        <p class="title">{{ gameData.Title }}({{ gameData.OriginalTitle }}) ({{gameData.DateBeginDate}}-{{gameData.DateEndDate}})</p>
        <p class="subtitle">di {{ gameData.devString }}</p>
        <div class="media">
            <div class="media-left">
            <figure class="image"  v-for="image in gameData.rawg.short_screenshots" :key="image.src" >
                <img
                :src="image.image"
                alt="Poster"
                style="max-width: 200px; max-height: 200px; padding-top: 5px;"
                />
            </figure>
            
            </div>

            <div class="media-content">
            <p v-if="gameData.tagline" class="subtitle"> </p>
            <p><i>Gioco in stato {{gameData.Status}} su {{ gameData.Platform }}</i></p> <br/>
            <p v-if="gameData.DatePurchaseDate" >Procurato il {{gameData.DatePurchaseDate}}</p>
            <p v-if="gameData.DateBeginDate" >Iniziato il {{gameData.DateBeginDate}} e {{gameData.DateEndDate?"finito il "+ gameData.DateEndDate:"non finito"}}</p>
            <p>{{gameData.overview}}</p><br/>
            
            <p class="is-size-7">{{gameData.rawg.description_raw}}></p>
            
            
             <p>{{gameData.Comment}}                         
             
             <star-rating v-if="gameData.Dicks"
                    v-model="gameData.Dicks"
                    :show-rating="false"
                    :read-only="true"
                    :increment="0.5"
                    :star-size="30"
                  /></p>
            </div>
        </div>
        </div>
        <footer class="card-footer">
        <a href="#" @click="doEdit" class="card-footer-item">Edit</a>
        <a href="#" @click="doDelete" class="card-footer-item">Scancellalo!</a>
        <a :href="'https://rawg.io/games/'+gameData.rawg.slug" target="_blank" class="card-footer-item">Rawg</a>
        <a href="#" @click= "doClose" class="card-footer-item">Chiudi</a>
        </footer>
    </div>
</template>

<script>
import StarRating from "vue-star-rating";
export default {
  name: 'GameDetails',
  components: { StarRating  },
  methods: {
   doEdit() {
      this.$emit("GameDetailsEdit"); 
   }  ,
   doDelete() {
      this.$emit("GameDetailsDelete"); 
   },
   doNewSeason() {
      this.$emit("GameDetailsNewSeason"); 
   },
   doClose() {
      this.$parent.close();
   } 
  },
  props: ['gameData'],
  
  data() {
    return {
    };
  },
  mounted() {
    
  }
};
</script>

<style lang="scss">


</style>